module.exports = __webpack_public_path__ + "static/media/MealHelpr.a71ea6eb.png";